import GeneralModel from "./../../general/GeneralModel";
import MonitorScoreExam from "./MonitorScoreExam";
import MonitorScoreExamsFilter from "./MonitorScoreExamsFilter";

export default class MonitorScoreExams extends GeneralModel {
  constructor() {
    super();
    this.setInitialValue();
  }
  setInitialValue() {
    this.setGeneralModelInitialValue();
    this.MonitorScoreExamsData = [];
    this.MonitorScoreExam = new MonitorScoreExam();
    this.filterData = new MonitorScoreExamsFilter();
  }
  fillData(data) {
    if (data) {
      this.fillGeneralModelData(data);
      this.MonitorScoreExamsData = data.monitorScoreExamsData || [];
      let filter = { ...this.filterData, ...data.pagination };
      this.filterData.fillData(filter);
    } else {
      this.setInitialValue();
    }
  }
}
